<script>
import BaseForm from './base-form';
import Attachment from './attachment';

export default {
    data: function() {
        return {
            ...BaseForm.data(),
            analytics: true,

            picker_state: {
                disabled: {}
            },

            fields: {
                service_items: [],
                selected_regions: [],
                selected_communities: ''
            },

            config: {
                service_items: {
                    min: 1,
                    max: 5
                }
            },

            communities: [],
            formSuccess: false,
            attachments: new Attachment()
        }
    },

    mounted() {
        this.boot();
        this.getCommunities();
        this.initServiceItems();
    },

    computed: {
        ...BaseForm.computed,

        serviceItemCount() {
            if(!this.fields.service_items) {
                return 0;
            }

            return this.fields.service_items.length;
        },

        canAddServiceItems() {
            return this.serviceItemCount < this.config.service_items.max;
        },

        regions() {
            return this.fields.selected_regions;
        }
    },

    watch: {
        ...BaseForm.watchers,

        regions() {
            this.getCommunities();
        }
    },

    methods: {
        ...BaseForm.methods,

        getCommunities() {
            Tortilla.Xhr.get('api/warranty/communities', {
                region_ids: this.regions
            }).then(res => this.communities = res.data);
        },

        initServiceItems() {
            for(let i = 0; i < this.config.service_items.min; i++) {
                this.addServiceItem();
            }
        },

        submit(event) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                this.beforeSubmit().then((token) => {

                    // Make a request to the session heartbeat to ensure the session
                    // is refreshed if it has gone stale.
                    Tortilla.Xhr.get('/api/session/heartbeat').then(() => {
                        this.submitForm(event, token);
                        });
                    });
                }
            });
        },

        submitForm(event, token) {
            if(this.attachments.waitingOnUploads()) {
                return requestAnimationFrame(() => this.submitForm(event, token));
            }

            this.form.post(event.target.action, {
                ...this.fields, ...this.persistents,
                'g-recaptcha-response': token
            })
            .then((result) => {
                this.success(result, event);
                this.initServiceItems();
            })
            .catch(() => this.failure());
        },

        addServiceItem() {
            if(!this.fields.service_items) {
                this.fields.service_items = [];
            }

            this.fields.service_items.push({image: undefined});
        },

        removeServiceItem() {
            this.fields.service_items.pop();
        },

        isServiceItemRequired(key) {
            return key === 0;
        },

        uploadAttachment(event, key) {
            const target = event.target;

            this.attachments.upload(event)
                .then(({data}) => this.successUpload(target, data, {key}))
                .catch(({response}) => this.failureUpload(target, response));
        },

        discardAttachment(id, key) {
            document.getElementById(id).value = '';
            this.fields.service_items[key].image = undefined;
        },

        hasAttachment(key) {
            return !! this.fields.service_items[key].image;
        },

        successUpload(target, data, options) {
            this.fields.service_items[options.key].image = data.key;
        },

        failureUpload(target, error) {
            this.attachments.decrementCount();

            if (error.status && error.status >= 400 && error.status < 500) {
                let bag = [];
                const errors = {};

                if (typeof error.data.errors !== 'undefined') {
                    bag = error.data.errors[
                        Object.keys(error.data.errors)[0]
                    ];
                }

                // Push general message to the bottom of the bag as a catch-all.
                bag.push('Something went wrong, please try again later.');

                errors[target.id] = bag;

                this.form.errors.fill(errors);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/forms/submit-service-request.vue